
export enum FieldType {
  String = 0,
  Float,
  Int,
  Text,
  Boolean,
  Date,
  Time,
  DateTime,
  File,
  Password
}

export enum SortType {
  Asc = 0,
  Desc
}

export enum FormStatus {
  View = 0,
  Edit,
  Insert,
  Copy
}

export enum SearchType {
  Equal = 0,
  NotEqual,
  In,
  NotIn,
  Contains,
  StartWith,
  EndWith
}

export enum ServiceCode {
  Success = 200,
  ValidateError = 300,
  SystemError = 500,
}

export interface FieldDefine {
  name: string;
  type: FieldType;
  caption: string;
  decimal: number;
  editable: boolean;
  update: boolean;
  insert: boolean;
  sortable: boolean;
  searchable: boolean;
  key: boolean;
  show: boolean;
  excel: boolean;
  required: boolean;
  listValues: any [][];
  listKendoValues: {[key: string]: any} [];
  listParam: any;
  listName: string;
  choices: boolean;
  simpleChoices: boolean;
  autocompleteChoices: boolean;
  tree: boolean;
  autocomplete: boolean;
  width: number;
  dropdownWidth: any;
  summary: boolean;
  defaultValue: any;
  hidden: boolean;
  image: boolean;
  imageParams: string;
  // visibleSearchBox: boolean;
  groupName: string;
  locked: boolean;
  groupFirstItem: boolean;
  groupFirstEditItem: boolean;
  editMode: boolean;
}

export interface FieldDefineGroup {
  groupName: string;
  field: FieldDefine;
  fields: FieldDefine[];
}

export interface SearchDefine {
  name: string;
  type: SearchType;
  value1: string;
  value2: string;
  values: any;
  searchNull: boolean;
}

export interface FormDefine {
  backward: boolean;
  fields: FieldDefine[];
  fieldGroups: FieldDefineGroup[];
  fieldByNames: {[key: string]: FieldDefine};
  name: string;
  action: string;
  pageIndex: number;
  pageSize: number;
  sortInfo: { [key: string]: SortType };
  searchInfo: { [key: string]: SearchDefine };
  summaries: { [key: string]: number };
  invalidInfo: { [key: number]: any };
  total: number;
  optionInsert: boolean;
  optionDelete: boolean;
  optionUpdate: boolean;
  optionImport: boolean;
  optionExcel: boolean;
  optionWord: boolean;
  optionPDF: boolean;
  optionsMap: {[key: string]: Array<any>};
}

export interface FormServerData {
  total: number;
  data: any[];
  summary: {[key: string]: number};
  list: {[key: string]: any};
  extra: any;
}

export interface BackItem {
  formName: string;
  sortInfo: { [key: string]: SortType };
  searchInfo: { [key: string]: SearchDefine };
  pageIndex: number;
  pageSize: number;
  path: string;
  params: {[key: string]: any };
}

export interface User {
  token: string;
  name: string;
  login_id: string;
  id: number;
  email: string;
  roles: string []; // role code list. Ex: manager,admin,account
  module_permission: {[key: string]: string[]}; // module code: permission code list
  api_path: {[key: string]: string}; // api code: path
  module_path: {[key: string]: string}; // module code: path
  api_module: {[key: string]: string[]}; // api code: module code list
}

export const Locale = {
  Vietnam: 'vi',
  England: 'en',
  Japan: 'ja',
};

// export const DateFormat = {
//   Date: 'yyyy/MM/dd',
//   DateTime: 'yyyy/MM/dd HH:mm:ss',
// };
// export const dateFormat = 'yyyy/MM/dd';
// export const dateTimeFormat = 'yyyy/MM/dd HH:mm:ss';

export const actionDelete = 'delete';
export const actionUpdate = 'update';
export const actionInsert = 'insert';
export const actionCopy = 'copy';
export const actionSetting = 'setting';
export const actionResetSetting = 'reset_setting';
export const actionDefine = 'define';
export const actionData = 'data';
export const actionExcel = 'excel';
export const actionExport = 'export';
export const actionDownload = 'download';
export const actionImport = 'import';
export const actionSample = 'sample';
export const actionParamName = '__action__';
export const serialParamName = '__serial__';
export const downloadFieldParamName = '__download_field__';
export const downloadIdParamName = '__download_id__';
export const downloadThumbnailParamName = '__download_thumbnail__';
export const requestParamNameSuffix = '[]';



